export function PageHeader({ overline, title, children }) {
  return (
    <div className="sticky top-0 z-10 bg-white/80 backdrop-blur-xl border-b border-black/10">
      <div className="h-16 px-8 flex items-center justify-between">
        <div>
          {overline && <p className="overline text-[0.6rem] leading-none mb-1">{overline}</p>}
          <h1 className="font-heading font-bold text-lg tracking-tight leading-none">{title}</h1>
        </div>
        <div className="flex items-center gap-3">{children}</div>
      </div>
    </div>
  );
}

export function StatBadge({ label, value }) {
  return (
    <div className="px-4 py-2 border border-black/10 bg-white">
      <p className="font-heading font-black text-lg leading-none">{value}</p>
      <p className="overline text-[0.55rem] mt-1">{label}</p>
    </div>
  );
}

export function Empty({ icon: Icon, title, hint }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      {Icon && <Icon className="h-10 w-10 text-muted-foreground/40 mb-4" strokeWidth={1} />}
      <p className="font-heading font-bold text-lg">{title}</p>
      {hint && <p className="text-sm text-muted-foreground mt-1 max-w-xs">{hint}</p>}
    </div>
  );
}
